const taxNavPrimary = document.querySelectorAll('.taxNav-primary');
const primaryNavItems = document.querySelectorAll('ul.primaryNav > li');
const taxNavPrimaryItems = document.querySelectorAll('.taxNavWrap .taxNav-primary li');

const setActiveClass = elem => {
  elem.classList.remove('inactive');
  elem.classList.add('active');
};

const setInactiveClass = elem => {
  elem.classList.remove('active');
  elem.classList.add('inactive');
};

const closeTaxNav = () => {
  primaryNavItems.forEach(elem => {
    setInactiveClass(elem);
  });
  taxNavPrimaryItems.forEach(elem => {
    setInactiveClass(elem);
  });
};

const createCloseBtn = () => {
  taxNavPrimary.forEach(el => {
    const closeBtn = document.createElement('a');
    closeBtn.className = 'closeBtn';
    el.appendChild(closeBtn);
  });
};

createCloseBtn();

document.addEventListener('click', e => {
  const { target } = e;
  const targetParent = target.parentElement;

  // Exit out if close button clicked.
  if (target.classList.contains('closeBtn')) {
    closeTaxNav();
  }

  // Handle primary menu items.
  else if (targetParent.classList.contains('primaryNav')) {
    if (target.classList.contains('inactive')) {
      closeTaxNav();
      setActiveClass(target);
    } else if (target.classList.contains('active')) {
      setInactiveClass(target);
    }
  }

  // Handle the primary tax nax section.
  else if (targetParent.classList.contains('taxNav-primary')) {
    if (target.classList.contains('menu-item-has-children')) {
      e.preventDefault();
    }

    taxNavPrimaryItems.forEach(elem => {
      setInactiveClass(elem);
    });

    if (target.classList.contains('inactive')) {
      setActiveClass(target);
    } else if (target.classList.contains('active')) {
      setInactiveClass(target);
    }
  }

  // Close nav if not clicking on nav items.
  else if (
    !target.classList.contains('taxNav-primary') &&
    !target.classList.contains('taxNav-secondary') &&
    !target.classList.contains('menu-item') &&
    !targetParent.classList.contains('taxNav-primary') &&
    !targetParent.classList.contains('taxNav-secondary') &&
    !targetParent.classList.contains('menu-item')
  ) {
    closeTaxNav();
  }
});
